import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"

import MainLayout from "../layouts/main-layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Button from "../components/button"
import SignUp from "../components/sign-up"

import socialFb from "../images/Facebook.png"
import socialTwitter from "../images/Twitter.png"
import socialInstagram from "../images/Instagram.png"
import socialLinkedIn from "../images/LinkedIN.png"

import appWeb from "../images/web.png"
import appAndroid from "../images/android.png"
import appApple from "../images/apple.png"

import fbImage from "../images/fb-image.jpg"

import DynamicLinkBuilder from "../helpers/dynamic-link-builder"

import { REACT_APP_PACKAGE_NAME } from "../helpers/dynamic-link-builder"

const CAMPAIGN_REFERENCE = "cooking-with-kin"
const CAMPAIGN_READ_MORE = "https://thekinapp.com/"

const CAMPAIGN_SIGNED_UP = "campaign_signed_up"
const CAMPAIGN_CLICKED_MORE = "campaign_clicked_more"
const CAMPAIGN_CLICKED_VIDEO = "campaign_clicked_video"
const CAMPAIGN_CLICKED_NEWSLETTER = "campaign_clicked_newsletter"

const CAMPAIGN_CLICKED_ANDROID_APP_ICON = "campaign_android_download"
const CAMPAIGN_CLICKED_IOS_APP_ICON = "campaign_ios_download"
const CAMPAIGN_CLICKED_WEB_APP_ICON = "campaign_web_download"

const segmentEvent = eventName => {
  window.analytics.track(eventName, {
    campaign: CAMPAIGN_REFERENCE,
  })
}

const IndexPage = () => {
  const [showModal, setModal] = useState(false)

  useEffect(() => {
    console.log(process.env.NODE_ENV)
    if (process.env.NODE_ENV === "production") {
      if (typeof window !== `undefined` && window.analytics) {
        window.analytics.page("campaign", "Cooking like Dale & Reuben")
      }
      if (typeof window !== `undefined` && window.ga) {
        window.ga("send", "pageview", window.location.pathname)
      }
    }
  }, [])
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "image-placeholder.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderPhone: file(relativePath: { eq: "phone-placeholder.png" }) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      backgroundImageExperiences: file(
        relativePath: { eq: "experiences-bg.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      videoPlaceholder: file(relativePath: { eq: "video-placeholder.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const description =
    "Check out Dale Steyn and Reuben Riffel’s Ultimate Holiday Fish Braai, get the recipe for free and R100 off the Buyfresh Fish Braai box."

  return (
    <MainLayout>
      <SEO
        title="Cook like Dale &amp; Reuben"
        image={fbImage}
        description={description}
      />
      <section className="site-section site-section-primary">
        <div className="centered-content section-content-loose m-below-header text-center-mobile">
          <h1>Dale &amp; Reuben’s fish braai</h1>
          <p>Create this experience with your friends.</p>
          <Button
            onClick={e => {
              e.preventDefault()
              segmentEvent(CAMPAIGN_CLICKED_NEWSLETTER)
              setModal(true)
            }}
          >
            Get the recipe
          </Button>
        </div>
      </section>
      <section className="site-section section-video">
        <div className="centered-content">
          <div className="video-content">
            <div id="video">
              {/* <Img fluid={data.videoPlaceholder.childImageSharp.fluid} /> */}
              <iframe
                src={`https://player.vimeo.com/video/379003363?title=0&byline=0&portrait=0`}
                width="640"
                height="360"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              ></iframe>
            </div>
            <h3>
              Experiences with friends are better without the awkward money
              stuff.
            </h3>
          </div>
        </div>
      </section>
      <section className="site-section site-section-secondary">
        <div className="centered-content section-content">
          <div className="app-display">
            <div className="app-display-description">
              <div>
                <h3
                  style={{
                    marginBottom: "1.6rem",
                  }}
                >
                  Start something with Kin.  Buy the stuff. Get paid back.
                </h3>
                <ul style={{ marginBottom: "1.2rem" }}>
                  <li>Set up groups for the things you do together</li>
                  <li>Invite your friends</li>
                  <li>Track the shared expenses</li>
                  <li>Pay and get paid back</li>
                </ul>
                <Button
                  internal={false}
                  onClick={() => {
                    segmentEvent(CAMPAIGN_SIGNED_UP)
                  }}
                  url={`https://web.thekinapp.com/?ref=${CAMPAIGN_REFERENCE}`}
                >
                  Sign up
                </Button>
              </div>
            </div>
            <div className="app-display-phone">
              <Img fluid={data.placeholderPhone.childImageSharp.fluid} />
            </div>
          </div>
        </div>
      </section>
      <section
        className="site-section site-section-tertiary"
        style={{ display: "flex" }}
      >
        <div className="section-content-loose centered-content text-center">
          <h2 className="title-secondary">
            Manage money better with friends today.
          </h2>
          <Button
            onClick={() => segmentEvent(CAMPAIGN_CLICKED_MORE)}
            type="secondary light"
            url="https://thekinapp.com/how-it-works/"
            internal={false}
            target="_blank"
          >
            How it works
          </Button>
          <div className="app-icons">
            <a
              className="app-cta"
              href={DynamicLinkBuilder.buildLink(
                `https://itunes.apple.com/us/app/kin/id1437611153`
              )}
              onClick={() => segmentEvent(CAMPAIGN_CLICKED_IOS_APP_ICON)}
            >
              <img src={appApple} alt="IOs App Icon" />
            </a>
            <a
              className="app-cta"
              href={DynamicLinkBuilder.buildLink(
                `https://play.google.com/store/apps/details?id=${REACT_APP_PACKAGE_NAME}`
              )}
              onClick={() => segmentEvent(CAMPAIGN_CLICKED_ANDROID_APP_ICON)}
            >
              <img src={appAndroid} alt="Android App Icon" />
            </a>
            <a
              className="app-cta"
              href={`https://web.thekinapp.com/?ref=${CAMPAIGN_REFERENCE}`}
              onClick={() => segmentEvent(CAMPAIGN_CLICKED_WEB_APP_ICON)}
            >
              <img src={appWeb} alt="Web App Icon" />
            </a>
          </div>
          <div className="social-icons">
            <a
              target="_blank"
              href="https://instagram.com/justkinme"
              className="social-icon"
            >
              <img src={socialInstagram} alt="Follow Kin on Instagram." />
            </a>
            <a
              target="_blank"
              href="https://facebook.com/justkinme"
              className="social-icon"
            >
              <img src={socialFb} alt="Follow Kin on Facebook." />
            </a>
            <a
              target="_blank"
              href="https://twitter.com/justkinme"
              className="social-icon"
            >
              <img src={socialTwitter} alt="Follow Kin on Twitter." />
            </a>
            <a
              target="_blank"
              href="https://linkedin.com/company/kindigital"
              className="social-icon"
            >
              <img src={socialLinkedIn} alt="Follow Kin on LinkedIn." />
            </a>
          </div>
        </div>
      </section>
      <SignUp
        show={showModal}
        close={() => {
          setModal(false)
        }}
      />
    </MainLayout>
  )
}

export default IndexPage
